/**
 * Componente OpinionsSection
 * Wrapper para el formulario de opiniones
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import MotionWrapper from "../../shared/components/MotionWrapper";
import OpinionForm from "./OpinionForm";

const OpinionsSection = () => {
    const navigate = useNavigate();

    return (
        <MotionWrapper
            sectionKey="opiniones"
            className="absolute inset-0 flex items-center justify-center text-center bg-black bg-opacity-90"
        >
            <OpinionForm onBack={() => navigate(-1)} />
        </MotionWrapper>
    );
};

export default OpinionsSection;
